import { StatusCodes } from "http-status-codes";
import { HOSPITAL_APIS } from "../utils/constants";
import {
  IHospitalFetchResponse,
  IHospitalSchemeCode,
  IHospitalSchemeFetchResponse,
} from "../interfaces/IHospital";
import Axios from "../utils/axiosInterceptor"; // Adjust the import path as necessary

// TODO: Use proper type in response
export const getAllHospitals = async (): Promise<any> => {
  try {
    const response = await Axios.get<Array<IHospitalFetchResponse>>(
      HOSPITAL_APIS.ALL_HOSPITALS
    );

    if (response.status === StatusCodes.OK) {
      return { hospitalsData: response.data, status: response.status };
    } else {
      return {
        errorMessage: "Cannot fetch available hospitals",
        status: response.status,
      };
    }
  } catch (error) {
    console.error("Error fetching available hospitals:", error);
    throw new Error("Cannot fetch available hospitals");
  }
};

export const getSchemeCodes = async (
  hospitalId: number,
  schemeName: string
): Promise<IHospitalSchemeFetchResponse> => {
  try {
    const response = await Axios.get<Array<IHospitalSchemeCode>>(
      HOSPITAL_APIS.GET_HOSPITAL_SCHEMES_API(hospitalId),
      {
        params: { schemeName },
      }
    );
    if (response.status === StatusCodes.OK) {
      return {
        response: {
          schemes: response.data,
        },
        status: response.status,
        errorMessage: null,
      };
    } else {
      return {
        response: null,
        errorMessage: "Cannot get edit ipd bill",
        status: response.status,
      };
    }
  } catch (error) {
    throw new Error("Cannot get edit ipd bill");
  }
};
